"use strict";
/*!
 * Copyright (C) 2019, NewFoundry, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.Response = void 0;

var lodash_1 = __importDefault(require("lodash"));

var ChangeLog_1 = require("./ChangeLog");

var helper_1 = require("./helper");

var Response = function () {
  function Response(engine, opts) {
    if (opts === void 0) {
      opts = {};
    }

    this.before = {};
    this.after = {};
    this.changes = [];
    this.overrides = [];
    this.diffs = [];
    this.rules = [];
    this.inversions = [];
    this.engine = engine;
    this.log = new ChangeLog_1.ChangeLog(this);
    this.startTime = new Date().getTime();

    if (opts.debug) {
      this.debug = true;
    }
  }

  Response.prototype.diff = function (before, after) {
    var diff = helper_1.diffConfigurations(before, after);
    this.diffs.push(diff);
    return diff;
  };

  Response.prototype.finish = function () {
    var diff = helper_1.diffConfigurations(this.before, this.after);
    var log = this.log.finish(diff, this.selection, this.after);
    var changes = log.changes,
        forces = log.forces;
    var msg = {
      before: this.before,
      after: this.after,
      diff: diff,
      selection: this.selection,
      changes: changes,
      forces: forces,
      overrides: lodash_1["default"].uniqWith(this.overrides, lodash_1["default"].isEqual)
    };

    if (this.err) {
      msg.err = this.err;
    }

    if (this.debug) {
      msg.debug = {
        diffs: this.diffs,
        iterations: this.diffs.length,
        rules: this.rules.map(function (r) {
          return r.orig;
        }),
        inversions: this.inversions,
        version: '1.1.7'
      };
      this.endTime = new Date().getTime();
      msg.debug.duration = this.endTime - this.startTime;
    }

    return msg;
  };

  Response.prototype.getSelection = function () {
    return this.selection;
  };

  return Response;
}();

exports.Response = Response;